





































import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Question,
    },
    questions: {
      type: Array as () => Question[],
    },
  },

  computed: {
    keys(): any {
      return (this.questions || [])
        ?.filter((question) => question.questiontype.key === 'multiple_choice')
        .map((question) => ({
          text: question.questionkey,
          value: question.questionkey,
        }));
    },

    answers(): any {
      const question = this.questions?.find(
        (question) => question.questionkey === this.value.condition?.key
      );
      if (question && question.questiontype?.key === 'multiple_choice') {
        return question.options?.choices?.map((choice: any) => choice.key);
      } else {
        return [];
      }
    },
  },

  mounted() {
    this.$emit('input', {
      condition: {
        key: this.value.condition?.key,
        answers: this.value.condition?.answers || [],
      },
    });
  },
});
